import { render, staticRenderFns } from "./RoleSetting.vue?vue&type=template&id=0e5d27bc"
import script from "./RoleSetting.vue?vue&type=script&lang=js"
export * from "./RoleSetting.vue?vue&type=script&lang=js"
import style0 from "./RoleSetting.vue?vue&type=style&index=0&id=0e5d27bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports